import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LogisticRoutePageComponent} from './view/logistic-route-page/logistic-route-page.component';
import {LogisticRoutesRoutingModule} from './logistic-routes-routing.module';
import {RouterModule} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {RippleModule} from 'primeng/ripple';
import {MatRippleModule} from '@angular/material/core';
import {MiscModule} from '../../../../../core/src/lib/misc/misc.module';
import {MatDialogModule} from '@angular/material/dialog';
import {
  LogisticVehicleEditDialogComponent
} from './view/logistic-route-page/logistic-vehicle-edit-dialog/logistic-vehicle-edit-dialog.component';
import {InputTextModule} from 'primeng/inputtext';
import {ActivityRouteComponent} from './view/logistic-route-page/activity-route/activity-route.component';
import {CheckboxModule} from 'primeng/checkbox';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {
  LogisticPlanningWeekComponent
} from './view/logistic-route-page/logistic-planning/logistic-planning-week/logistic-planning-week.component';
import {
  LogisticPlanningDayComponent
} from './view/logistic-route-page/logistic-planning/logistic-planning-week/logistic-planning-day/logistic-planning-day.component';
import { SuggestionActivityComponent } from './view/logistic-route-page/logistic-planning/logistic-planning-week/logistic-planning-day/suggestion-activity/suggestion-activity.component';

@NgModule({
  declarations: [
    LogisticRoutePageComponent,
    LogisticVehicleEditDialogComponent,
    ActivityRouteComponent,
    LogisticPlanningWeekComponent,
    LogisticPlanningDayComponent,
    SuggestionActivityComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    LogisticRoutesRoutingModule,
    DropdownModule,
    FormsModule,
    RippleModule,
    MatRippleModule,
    MiscModule,
    InputTextModule,
    CheckboxModule,
    DragDropModule
  ],
  exports: [
    RouterModule
  ]
})
export class LogisticRoutesModule {
}
